import React, { useEffect, useState } from "react";
import "screens/Landpage/landpage.css";
import "./tv.css";
import Cabecalho from "components/LandpageNova/Cabecalho";
import Selos from "components/LandpageNova/Selos";
import PlanosCartoes from "components/LandpageNova/PlanosCartoes";
import Rodape from "components/LandpageNova/Rodape";

// Página de quem chega pela TV (03/10/2026; refeita em 05/10 no desenho da página inicial nova).
// Em 14 dias, umas 10 casas por dia abriram o app na TV SEM ter conta e desistiram: aqui ficam
// as TVs em que o app existe e os dois caminhos (assinar pelo site ou conectar a TV).
// A assinatura é feita SÓ pelo site: os apps das lojas são usados por crianças e não podem
// levar para fora deles.

// Algumas marcas têm modelos com sistemas diferentes (Philco e TCL têm Google TV e Roku TV):
// por isso a página fala do sistema e dá as marcas como exemplo.
const SISTEMAS = [
  {
    nome: "Samsung",
    cor: "var(--primary)",
    quais: "Smart TVs Samsung fabricadas a partir de 2019.",
    loja: "Na TV, abra Apps e pesquise JoinKids.",
  },
  {
    nome: "LG",
    cor: "var(--secondary)",
    quais: "Smart TVs LG fabricadas a partir de 2020.",
    loja: "Na TV, abra a LG Content Store e pesquise JoinKids.",
  },
  {
    nome: "Google TV e Android TV",
    cor: "var(--accent)",
    quais: "TVs com Google TV ou Android TV, como TCL, Philips, Philco, AIWA, Toshiba, Sony e Xiaomi, e aparelhos com Google TV ligados na TV.",
    loja: "Na TV, abra a Google Play Store (no Google TV, a aba Apps) e pesquise JoinKids.",
  },
  {
    nome: "Roku",
    cor: "var(--green)",
    quais: "TVs com Roku TV, como AOC, Philco, Semp, TCL e Britânia, e os aparelhos Roku, como o Roku Express.",
    loja: "Na tela inicial, abra a loja de canais da Roku e pesquise JoinKids.",
  },
];

const PASSOS = [
  { titulo: "Instale o app na TV", texto: "Na loja da sua TV, pesquise JoinKids e instale. Veja acima onde fica a loja de cada TV." },
  { titulo: "Gere o código no celular", texto: "No app JoinKids do celular, toque em Perfil, depois em Acesso à TV e em Gerar código." },
  { titulo: "Digite o código na TV", texto: "Digite os 5 números na TV e aperte Entrar. O código vale por 1 hora e só o mais novo funciona." },
];

const DUVIDAS = [
  {
    q: "Posso assinar pelo app da TV ou do celular?",
    a: "Não. A assinatura é feita só aqui, pelo nosso site, no celular ou no computador. Os apps da TV e do celular servem para assistir: depois de assinar, é só entrar no app do celular com o seu e-mail e a sua senha e conectar a TV com o código.",
  },
  {
    q: "O código não funcionou. O que eu faço?",
    a: "O código vale por 1 hora e só o mais novo funciona. Gere um novo no app do celular (Perfil, Acesso à TV, Gerar código) e digite os 5 números na TV. Se mesmo assim não der certo, fale com a gente no WhatsApp.",
  },
  {
    q: "Minha TV não está na lista. Consigo assistir?",
    a: "Sim. Você pode ligar na TV um aparelho com Google TV ou um aparelho Roku e instalar a JoinKids nele. Também dá para assistir no celular, no tablet e no computador.",
  },
  {
    q: "Quantas crianças podem assistir ao mesmo tempo?",
    a: "Até 3 telas ao mesmo tempo, com a mesma assinatura.",
  },
];

// Ícone de TV no traço das figuras da página inicial (sem emoji nas telas).
const IconeTV = ({ cor }) => (
  <svg className="tv-icone" viewBox="0 0 48 48" aria-hidden="true" focusable="false" style={{ color: cor }}>
    <rect x="4" y="7" width="40" height="27" rx="3.5" fill="none" stroke="currentColor" strokeWidth="3.5" />
    <path d="M24 34v6M14 41h20" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" />
  </svg>
);

export default function Tv() {
  const [duvidaAberta, setDuvidaAberta] = useState(0);

  useEffect(() => {
    document.title = 'Assista a JoinKids na sua TV | JoinKids';
    const descricao = document.querySelector('meta[name="description"]');
    if (descricao) descricao.setAttribute('content', 'Veja em quais TVs a JoinKids funciona (Samsung, LG, Google TV, Android TV e Roku) e como conectar a sua TV em 3 passos.');
    // Ao sair, a aba volta ao título da marca (o og:title que toda página tem). "O título de antes" não
    // serve: a foto de publicação já guarda esta página com o título dela.
    return () => {
      const marca = document.querySelector('meta[property="og:title"]');
      if (marca && marca.content) document.title = marca.content;
    };
  }, []);

  return (
    <div className="jk-lp">
      <Cabecalho logoParaInicio />

      {/* TOPO */}
      <section className="tv-hero">
        <div className="wrap tv-hero-grid">
          <div className="tv-hero-texto">
            <img className="hero-logo" src="/icons/logo_joinkids_banner.png" alt="JoinKids" />
            <h1>Assista a JoinKids <span className="hl">na sua TV</span></h1>
            <p className="sub">Desenhos, músicas e histórias cristãs na tela grande da sala, com segurança e sem anúncios.</p>
            <div className="tv-hero-acoes">
              <a className="btn btn-green" href="#planos">Quero assinar</a>
              <a className="btn btn-ghost" href="#conectar">Já sou assinante</a>
            </div>
            <div className="hero-trust">✓ Sem anúncios &nbsp;·&nbsp; ✓ Até 3 telas ao mesmo tempo &nbsp;·&nbsp; ✓ Cancele quando quiser</div>
          </div>
          <div className="tv-hero-img">
            <img src="/images/beneficios/beneficio_3.webp" alt="Família assistindo JoinKids na TV, no celular e no tablet" width="640" height="640" />
          </div>
        </div>
      </section>

      <Selos />

      {/* EM QUAIS TVs */}
      <section className="section" id="telas">
        <div className="wrap">
          <h2 className="sec-title">Em quais TVs funciona</h2>
          <p className="sec-sub">O app da JoinKids está nas lojas destas TVs. O nome do sistema aparece na tela inicial ou na caixa da sua TV.</p>
          <img className="tv-plataformas" src="/images/plataformas.webp" alt="App Store, Google Play, LG Smart TV, Samsung Smart TV, Web, Google TV e Roku" width="960" height="325" loading="lazy" />
          <div className="tv-sistemas">
            {SISTEMAS.map((s) => (
              <div className="tv-sistema" key={s.nome}>
                <IconeTV cor={s.cor} />
                <h3>{s.nome}</h3>
                <p>{s.quais}</p>
                <div className="tv-loja"><b>Onde achar:</b> {s.loja}</div>
              </div>
            ))}
          </div>
          <p className="tv-nota">Algumas marcas têm TVs com sistemas diferentes. Vale o nome do sistema que aparece na sua TV.</p>
        </div>
      </section>

      {/* CONECTAR */}
      <section className="section vitrine" id="conectar">
        <div className="wrap">
          <h2 className="sec-title">Já é assinante? Conecte sua TV</h2>
          <p className="sec-sub">São só 3 passos, e você faz uma vez só.</p>
          <ol className="tv-passos">
            {PASSOS.map((p, idx) => (
              <li className="tv-passo" key={p.titulo}>
                <span className="tv-num" aria-hidden="true">{idx + 1}</span>
                <h3>{p.titulo}</h3>
                <p>{p.texto}</p>
              </li>
            ))}
          </ol>
          <p className="tv-nota">
            Ainda não tem o app no celular? Baixe na{' '}
            <a href="https://apps.apple.com/br/app/joinkids-brasil/id6443968852" target="_blank" rel="noopener noreferrer">App Store</a>
            {' '}ou no{' '}
            <a href="https://play.google.com/store/apps/details?id=com.joinkids" target="_blank" rel="noopener noreferrer">Google Play</a>
            {' '}e entre com o e-mail e a senha da sua assinatura.
          </p>
        </div>
      </section>

      {/* PLANOS */}
      <section className="section cta" id="planos">
        <div className="wrap center">
          <h2 className="sec-title">Ainda não é assinante?</h2>
          <p className="sec-sub">A assinatura é feita só aqui, pelo nosso site, no celular ou no computador. Os apps da TV e do celular servem para assistir.</p>
          <PlanosCartoes />
          <p className="tv-nota">Quer conhecer os desenhos antes de assinar? <a href="/conteudos">Veja o catálogo</a>.</p>
        </div>
      </section>

      {/* DÚVIDAS */}
      <section className="section" id="faq">
        <div className="wrap">
          <h2 className="sec-title">Dúvidas sobre a TV</h2>
          <p className="sec-sub">As perguntas mais comuns de quem quer assistir na TV.</p>
          <div className="faq">
            {DUVIDAS.map((item, idx) => (
              <details key={item.q} open={idx === duvidaAberta} onToggle={(e) => { if (e.target.open) setDuvidaAberta(idx); }}>
                <summary>{item.q}</summary>
                <div className="ans">{item.a}</div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <Rodape />
    </div>
  );
}
